import React from 'react';
import { SecurityContextTemplate } from 'framework/authorization';
import { useProjectService } from 'domain/shared/project';

export const PROJECT_CONTEXT = 'Project';

const ProjectContext = ({
  permissionToCheck,
  children,
}: {
  permissionToCheck: string | string[];
  children: React.ReactNode;
}) => {
  const { getPermissions } = useProjectService();

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissions}
      permissionToCheck={permissionToCheck}
      contextName={PROJECT_CONTEXT}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default ProjectContext;
